import { Box, colors, Heading, Text } from "@biblioteksentralen/react";
import { CommonLinkStyling } from "../../../components/blockContent/LinkSerializer";
import { logClick } from "../../../utils/analytics/Plausible";
import { useFeatureToggle } from "../../../utils/hooks/featureToggles";
import { useLibrarySystemClient } from "../../../utils/hooks/useLibrarySystemClient";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { useSitePalette } from "../../../utils/useSitePalette";
import { useSearchContext } from "./SearchContext";

const OldSearchInfoBox = () => {
  const { searchState } = useSearchContext();
  const palette = useSitePalette();
  const { t, tRich } = useTranslation();
  const librarySystemClient = useLibrarySystemClient();
  const customBibliofilTekst = useFeatureToggle("customBibliofilTekst");

  if (!searchState?.s) return null;

  return (
    <Box width="100%" {...palette.colors.pop1.css} padding="1rem" borderRadius="lg">
      <Heading as="h3" fontSize="md" fontWeight="semibold" marginBottom="0.25rem" textColor={colors.black}>
        {t("Finner du ikke det du leter etter?")}
      </Heading>
      <Text display="inline">
        {tRich("Da kan du prøve <Link>det gamle søket</Link>. Der finner du blant annet kart og tidsskrifter.", {
          Link: (children) => (
            <CommonLinkStyling
              display="inline"
              href={searchState.s && librarySystemClient?.getLinkToSearch(searchState.s)}
              accentColor={colors.black}
              hoverColor={colors.grey60}
              onClick={() => logClick("Gå til det gamle søket")}
            >
              {customBibliofilTekst ? " Bibliofil" : children}
            </CommonLinkStyling>
          ),
        })}
      </Text>
    </Box>
  );
};

export default OldSearchInfoBox;
